import { render, staticRenderFns } from "./DepartureEdit.vue?vue&type=template&id=5a6b7a2b"
import script from "./DepartureEdit.vue?vue&type=script&lang=js"
export * from "./DepartureEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports